module.exports = __webpack_public_path__ + "img/dashboard-sidebar.153505b0.png";